/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Select_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Select Event Group" |
*
* @param {Event_Group_Sync_Select_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_select_placeholder = /** @type {((inputs?: Event_Group_Sync_Select_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Select_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Select Event Group")
	if (locale === "de") return /** @type {LocalizedString} */ ("Select Event Group")
	if (locale === "it") return /** @type {LocalizedString} */ ("Select Event Group")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Select Event Group")
	if (locale === "es") return /** @type {LocalizedString} */ ("Select Event Group")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Select Event Group")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Select Event Group")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Select Event Group")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Select Event Group")
	return /** @type {LocalizedString} */ ("Select Event Group")
});